import React from 'react'
import styled from 'styled-components'
import { Style } from 'radium'

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.6);
  top:0;
  left: 0;
  z-index: 9999999;
  display: ${props => props.open ? 'flex' : 'none'};
  justify-content: flex-start;
  align-items: flex-end;
`
const OnCloseArea = styled.div`
  width: 100%;
  height: 100%;
  z-index: 9999999;
`
const Modal = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #E2E8EC;
  z-index: 99999999;
`

const CancelButton = styled.div`
  width: 100%;
  color: #9B9B9B;
  display: flex;
  justify-content: center;
  padding: 8px 0 8px 0;
`
const ModalBottom = props => (
  <Overlay open={props.open}>
    {props.open &&
      <Style
        rules={{
          body: {
            overflow: 'hidden',
            height: '100%',
          },
          html: {
            overflow: 'hidden',
            height: '100%',
          },
        }}
      />
    }
    <OnCloseArea onClick={props.onClose} />
    <Modal>
      {props.children}
      <CancelButton onClick={props.onClose}>
        Cancel
      </CancelButton>
    </Modal>
  </Overlay>
)

export default ModalBottom



// WEBPACK FOOTER //
// ./src/Components/ModalBottom.jsx